/*eslint-disable*/
import * as Styled from '../styles';

export const RadioItem = ({ value, label, name, isSelected, onChange, children }) => {
  const handleChange = () => {
    onChange && onChange(value);
  };

  return (
    <Styled.RadioItemContainer>
      <Styled.RadioLabel>
        <Styled.RadioInputHidden type="radio" name={name} value={value} checked={isSelected} onChange={handleChange} />
        <Styled.RadioCircle className="radio-circle" isSelected={isSelected}>
          <Styled.RadioInnerCircle isSelected={isSelected} />
        </Styled.RadioCircle>
        <Styled.RadioLabelText className="radio-label" isSelected={isSelected}>
          {label}
        </Styled.RadioLabelText>
      </Styled.RadioLabel>

      {isSelected && children && <Styled.SubPanelContainer>{children}</Styled.SubPanelContainer>}
    </Styled.RadioItemContainer>
  );
};
